import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n/I18nContext";

const ease = [0.16, 1, 0.3, 1];

export default function Hero() {
  const { t } = useI18n();
  return (
    <section
      id="top"
      className="relative min-h-[88svh] md:min-h-[92svh] pt-32 md:pt-40 pb-16 md:pb-20 flex flex-col"
      data-testid="hero-section"
    >
      <div className="container-edge flex-1 flex flex-col">
        {/* Headline */}
        <div className="flex-1 flex flex-col justify-center">
          <h1
            className="display-light text-[44px] sm:text-[60px] md:text-[72px] lg:text-[92px] xl:text-[108px]"
            data-testid="hero-headline"
          >
            <motion.span
              className="block"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease, delay: 0.15 }}
            >
              {t.hero.lineA}
            </motion.span>
            <motion.span
              className="block"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease, delay: 0.3 }}
            >
              {t.hero.lineB}
            </motion.span>
            <motion.span
              className="block"
              style={{ fontWeight: 500 }}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease, delay: 0.45 }}
            >
              {t.hero.lineC}
            </motion.span>
          </h1>
        </div>

        {/* CTA */}
        <motion.div
          className="mt-16 md:mt-24"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease, delay: 0.7 }}
        >
          <a
            href="#whynow"
            className="mono-md under-link"
            style={{ color: "var(--ink)" }}
            data-testid="hero-cta"
          >
            {t.hero.cta}  ↓
          </a>
        </motion.div>
      </div>
    </section>
  );
}
